module.exports = __webpack_public_path__ + "img/17.a4d70164.jpg";